import { MarketingButton } from '@/components/marketing/marketing-button'
import { AccessRequestFormCore } from '@/components/access-request/access-request-form-core'
import { cn } from '@/lib/utils'

type WaitlistFormShellProps = {
  className?: string
}

const fieldClassName =
  'w-full rounded-2xl border border-white/15 bg-white/[0.08] px-[18px] py-4 text-[15px] text-white outline-none placeholder:text-white/55 focus:border-white/30'

const marketingSelectTriggerClassName = cn(
  fieldClassName,
  'h-auto shadow-none focus:ring-0 focus:ring-offset-0 [&>svg]:text-white/55',
)

const marketingSelectContentClassName =
  'rounded-2xl border border-white/15 bg-[#252a2e] text-white shadow-lg'

const marketingSelectItemClassName =
  'rounded-xl py-2.5 pl-3 pr-8 text-[15px] focus:bg-white/10 focus:text-white'

/** Marketing-band access request form (waitlist or invite-only tenants). */
export function WaitlistFormShell({ className }: WaitlistFormShellProps) {
  return (
    <AccessRequestFormCore
      variant="marketing"
      className={cn('mx-auto w-full max-w-[620px]', className)}
      formClassName="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-3"
      successPanelClassName="rounded-2xl border border-white/15 bg-white/[0.08] px-8 py-10 text-center"
      errorClassName="text-sm text-white sm:col-span-2 rounded-2xl border border-white/25 bg-white/[0.12] px-[18px] py-3"
      marketingFieldClassName={fieldClassName}
      marketingSelectTriggerClassName={marketingSelectTriggerClassName}
      marketingSelectContentClassName={marketingSelectContentClassName}
      marketingSelectItemClassName={marketingSelectItemClassName}
      formAriaLabel="Join the waitlist"
      renderSubmit={({ submitting, submitLabel }) => (
        <div className="sm:col-span-2">
          <MarketingButton variant="gold" type="submit" className="w-full text-base" disabled={submitting}>
            {submitting ? 'Submitting…' : submitLabel}
          </MarketingButton>
        </div>
      )}
    />
  )
}
